module.exports = __webpack_public_path__ + "media/images/canvas_logo_black-5a4696ec.svg";